import React, { useState } from 'react';

const CorazonWTF = () => {
  const [language, setLanguage] = useState('es'); // Spanish default
  const [formType, setFormType] = useState(null); // 'dinner' or 'work'
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    from: '',
    date: '',
    why: '',
    role: '',
    experience: ''
  });

  const content = {
    es: {
      location: 'San Blas · Nayarit · México',
      headline: 'Necesito a alguien que pruebe la comida.',
      pitch: 'La primera estrella Michelin en Nayarit no se va a ganar sola. Las recetas están listas. La cocina casi ready. Lo que falta es alguien del otro lado de la mesa que valga la pena.',
      btnDate: 'Seré tu cita',
      btnWork: 'Quiero chambear aquí',
      dateRange: 'Última semana de Diciembre, 2025 · Cena romántica para dos',
      flights: 'Sin compromisos. Solo comida y buena compañía.',
      formTitle: 'Cena a la luz de las velas',
      formSubtitle: 'Última semana de Diciembre, 2025 · San Blas, Nayarit',
      labelName: 'Nombre',
      labelEmail: 'Email',
      labelWhere: '¿De dónde eres?',
      placeholderWhere: 'Ciudad, País',
      labelWhy: '¿Por qué deberías ser mi cita?',
      placeholderWhy: 'Cuéntame algo real.',
      send: 'Enviar',
      deadline: 'Deadline: 20 de Diciembre · Ganadora anunciada el 22',
      preference: 'Se prefieren humanas plant-based · Buen gusto requerido',
      workTitle: 'Trabaja con nosotros',
      workSubtitle: 'Abrimos Enero 2025 · San Blas, Nayarit',
      labelRole: '¿Qué haces?',
      placeholderRole: 'Cocina, servicio, manager, lo que sea...',
      labelAbout: 'Cuéntame de ti',
      placeholderAbout: 'Experiencia, por qué San Blas, por qué esto...',
      workNote: 'Equipo pequeño · Cocina plant-based · No necesitas experiencia',
      workNote2: 'Solo que te importe lo que haces',
      thanks: 'Gracias',
      thanksDate: 'Voy a leer cada una. Si eres tú, lo sabrás el 22 de Diciembre.',
      thanksWork: 'Te escribo si hay fit. La cocina abre en Enero 2025.',
      back: '← atrás'
    },
    en: {
      location: 'San Blas · Nayarit · México',
      headline: 'I need someone to taste the food.',
      pitch: 'The first Michelin star in Nayarit won\'t win itself. The recipes are done. The kitchen is almost ready. What\'s missing is someone across the table who\'s worth cooking for.',
      btnDate: 'I\'ll be your date',
      btnWork: 'I want to work here',
      dateRange: 'December 24–28, 2025 · Candlelight dinner for two',
      flights: 'Flights and hotel included. No strings. Just food.',
      formTitle: 'Candlelight Dinner',
      formSubtitle: 'December 24–28, 2025 · San Blas, Nayarit',
      labelName: 'Name',
      labelEmail: 'Email',
      labelWhere: 'Where are you?',
      placeholderWhere: 'City, Country',
      labelWhy: 'Why you?',
      placeholderWhy: 'Tell me something real.',
      send: 'Send',
      deadline: 'Deadline: December 20 · Winner announced December 22',
      preference: 'Plant-based women preferred · Good taste required',
      workTitle: 'Work With Us',
      workSubtitle: 'Opening January 2025 · San Blas, Nayarit',
      labelRole: 'What do you do?',
      placeholderRole: 'Cook, server, manager, dishwasher, everything...',
      labelAbout: 'Tell me about yourself',
      placeholderAbout: 'Experience, why San Blas, why this...',
      workNote: 'Small team · Plant-based kitchen · No experience required',
      workNote2: 'Just give a damn about what you\'re doing',
      thanks: 'Gracias',
      thanksDate: 'I\'ll read every single one. If it\'s you, you\'ll know by December 22.',
      thanksWork: 'I\'ll be in touch if there\'s a fit. The kitchen opens January 2025.',
      back: '← back'
    },
    de: {
      location: 'San Blas · Nayarit · México',
      headline: 'Ich brauche jemanden, der das Essen probiert.',
      pitch: 'Der erste Michelin-Stern in Nayarit gewinnt sich nicht von allein. Die Rezepte sind fertig. Die Küche fast bereit. Was fehlt, ist jemand am Tisch, für den es sich lohnt zu kochen.',
      btnDate: 'Ich komme',
      btnWork: 'Ich will hier arbeiten',
      dateRange: '24.–28. Dezember 2025 · Dinner bei Kerzenlicht für zwei',
      flights: 'Flug und Hotel inklusive. Keine Bedingungen. Nur Essen.',
      formTitle: 'Dinner bei Kerzenlicht',
      formSubtitle: '24.–28. Dezember 2025 · San Blas, Nayarit',
      labelName: 'Name',
      labelEmail: 'Email',
      labelWhere: 'Wo bist du?',
      placeholderWhere: 'Stadt, Land',
      labelWhy: 'Warum du?',
      placeholderWhy: 'Erzähl mir was Echtes.',
      send: 'Senden',
      deadline: 'Deadline: 20. Dezember · Gewinnerin am 22. Dezember',
      preference: 'Plant-based Frauen bevorzugt · Guter Geschmack erforderlich',
      workTitle: 'Arbeite mit uns',
      workSubtitle: 'Eröffnung Januar 2025 · San Blas, Nayarit',
      labelRole: 'Was machst du?',
      placeholderRole: 'Koch, Service, Manager, alles...',
      labelAbout: 'Erzähl mir von dir',
      placeholderAbout: 'Erfahrung, warum San Blas, warum das hier...',
      workNote: 'Kleines Team · Plant-based Küche · Keine Erfahrung nötig',
      workNote2: 'Nur dass dir wichtig ist, was du tust',
      thanks: 'Danke',
      thanksDate: 'Ich lese jede einzelne. Wenn du es bist, weißt du es am 22. Dezember.',
      thanksWork: 'Ich melde mich, wenn es passt. Die Küche öffnet Januar 2025.',
      back: '← zurück'
    }
  };

  const t = content[language];

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  const LanguageSwitcher = () => (
    <div style={{
      position: 'absolute',
      top: '30px',
      right: '30px',
      display: 'flex',
      gap: '15px',
      zIndex: 10
    }}>
      {['es', 'en', 'de'].map((code) => (
        <button
          key={code}
          onClick={() => setLanguage(code)}
          style={{
            background: 'none',
            border: 'none',
            color: language === code ? '#f5f4f0' : 'rgba(201, 184, 150, 0.4)',
            fontSize: '14px',
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            letterSpacing: '2px',
            cursor: 'pointer',
            padding: '5px',
            textTransform: 'uppercase',
            transition: 'color 0.3s ease'
          }}
        >
          {code}
        </button>
      ))}
    </div>
  );

  // Landing - Choose Path
  if (!formType) {
    return (
      <div style={{
        fontFamily: "'Cormorant Garamond', 'Garamond', 'Georgia', serif",
        minHeight: '100vh',
        background: '#0a0a09',
        color: '#f5f4f0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        padding: '40px 20px'
      }}>
        {/* Texture */}
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
          opacity: 0.02,
          pointerEvents: 'none'
        }} />

        <LanguageSwitcher />

        <div style={{ textAlign: 'center', zIndex: 1, maxWidth: '600px' }}>
          {/* Header */}
          <div style={{
            fontSize: '13px',
            letterSpacing: '6px',
            textTransform: 'uppercase',
            color: 'rgba(201, 184, 150, 0.5)',
            marginBottom: '30px'
          }}>
            {t.location}
          </div>

          <h1 style={{
            fontSize: '62px',
            fontWeight: 300,
            letterSpacing: '15px',
            margin: '0 0 15px 0',
            fontStyle: 'italic'
          }}>
            Corazón
          </h1>

          <div style={{
            fontSize: '17px',
            letterSpacing: '3px',
            color: '#c9b896',
            marginBottom: '50px'
          }}>
            .wtf
          </div>

          <div style={{
            width: '80px',
            height: '1px',
            background: 'linear-gradient(90deg, transparent, #c9b896, transparent)',
            margin: '0 auto 50px auto'
          }} />

          {/* The Pitch */}
          <p style={{
            fontSize: '22px',
            fontWeight: 300,
            lineHeight: '2',
            color: 'rgba(245, 244, 240, 0.85)',
            fontStyle: 'italic',
            marginBottom: '20px'
          }}>
            {t.headline}
          </p>

          <p style={{
            fontSize: '17px',
            fontWeight: 300,
            lineHeight: '2',
            color: 'rgba(245, 244, 240, 0.5)',
            marginBottom: '60px',
            maxWidth: '450px',
            margin: '0 auto 60px auto'
          }}>
            {t.pitch}
          </p>

          {/* Two Options */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '20px',
            alignItems: 'center'
          }}>
            <button
              onClick={() => setFormType('dinner')}
              style={{
                background: 'none',
                border: '1px solid rgba(201, 184, 150, 0.4)',
                color: '#c9b896',
                fontSize: '16px',
                fontFamily: "'Cormorant Garamond', Georgia, serif",
                letterSpacing: '3px',
                cursor: 'pointer',
                padding: '20px 50px',
                width: '320px',
                transition: 'all 0.4s ease',
                textTransform: 'lowercase'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(201, 184, 150, 0.1)';
                e.target.style.borderColor = '#c9b896';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'none';
                e.target.style.borderColor = 'rgba(201, 184, 150, 0.4)';
              }}
            >
              {t.btnDate}
            </button>

            <button
              onClick={() => setFormType('work')}
              style={{
                background: 'none',
                border: '1px solid rgba(201, 184, 150, 0.2)',
                color: 'rgba(201, 184, 150, 0.6)',
                fontSize: '16px',
                fontFamily: "'Cormorant Garamond', Georgia, serif",
                letterSpacing: '3px',
                cursor: 'pointer',
                padding: '20px 50px',
                width: '320px',
                transition: 'all 0.4s ease',
                textTransform: 'lowercase'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(201, 184, 150, 0.05)';
                e.target.style.borderColor = 'rgba(201, 184, 150, 0.4)';
                e.target.style.color = '#c9b896';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'none';
                e.target.style.borderColor = 'rgba(201, 184, 150, 0.2)';
                e.target.style.color = 'rgba(201, 184, 150, 0.6)';
              }}
            >
              {t.btnWork}
            </button>
          </div>

          {/* Footer Note */}
          <p style={{
            fontSize: '15px',
            color: 'rgba(245, 244, 240, 0.3)',
            marginTop: '80px',
            fontStyle: 'italic'
          }}>
            {t.dateRange}
          </p>
          <p style={{
            fontSize: '14px',
            color: 'rgba(245, 244, 240, 0.2)',
            marginTop: '10px'
          }}>
            {t.flights}
          </p>

          {/* Social Icons */}
          <div style={{
            marginTop: '40px',
            display: 'flex',
            justifyContent: 'center',
            gap: '25px'
          }}>
            <a 
              href="https://instagram.com/corazon.restaurant" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{
                color: 'rgba(201, 184, 150, 0.4)',
                transition: 'color 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = '#c9b896'}
              onMouseLeave={(e) => e.target.style.color = 'rgba(201, 184, 150, 0.4)'}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
            </a>
            <a 
              href="https://x.com/corazonrestmx" 
              target="_blank" 
              rel="noopener noreferrer"
              style={{
                color: 'rgba(201, 184, 150, 0.4)',
                transition: 'color 0.3s ease'
              }}
              onMouseEnter={(e) => e.target.style.color = '#c9b896'}
              onMouseLeave={(e) => e.target.style.color = 'rgba(201, 184, 150, 0.4)'}
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
              </svg>
            </a>
          </div>
        </div>
      </div>
    );
  }

  // Thank You Screen
  if (submitted) {
    return (
      <div style={{
        fontFamily: "'Cormorant Garamond', 'Garamond', 'Georgia', serif",
        minHeight: '100vh',
        background: '#0a0a09',
        color: '#f5f4f0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        padding: '40px 20px'
      }}>
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
          opacity: 0.02,
          pointerEvents: 'none'
        }} />

        <div style={{ textAlign: 'center', zIndex: 1, maxWidth: '500px' }}>
          <h1 style={{
            fontSize: '50px',
            fontWeight: 300,
            letterSpacing: '10px',
            margin: '0 0 30px 0',
            fontStyle: 'italic'
          }}>
            {t.thanks}
          </h1>

          <div style={{
            width: '60px',
            height: '1px',
            background: 'linear-gradient(90deg, transparent, #c9b896, transparent)',
            margin: '0 auto 40px auto'
          }} />

          <p style={{
            fontSize: '19px',
            fontWeight: 300,
            lineHeight: '2',
            color: 'rgba(245, 244, 240, 0.7)',
            fontStyle: 'italic',
            marginBottom: '30px'
          }}>
            {formType === 'dinner' ? t.thanksDate : t.thanksWork}
          </p>

          <p style={{
            fontSize: '16px',
            color: 'rgba(201, 184, 150, 0.5)',
            marginTop: '60px'
          }}>
            corazon.restaurant
          </p>
        </div>
      </div>
    );
  }

  // Dinner Date Form
  if (formType === 'dinner') {
    return (
      <div style={{
        fontFamily: "'Cormorant Garamond', 'Garamond', 'Georgia', serif",
        minHeight: '100vh',
        background: '#0a0a09',
        color: '#f5f4f0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        padding: '60px 20px'
      }}>
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
          opacity: 0.02,
          pointerEvents: 'none'
        }} />

        <LanguageSwitcher />

        {/* Back button */}
        <button
          onClick={() => setFormType(null)}
          style={{
            position: 'absolute',
            top: '30px',
            left: '30px',
            background: 'none',
            border: 'none',
            color: 'rgba(201, 184, 150, 0.5)',
            fontSize: '14px',
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            cursor: 'pointer',
            letterSpacing: '2px'
          }}
        >
          {t.back}
        </button>

        <div style={{ textAlign: 'center', zIndex: 1, maxWidth: '500px', width: '100%' }}>
          <h2 style={{
            fontSize: '34px',
            fontWeight: 300,
            letterSpacing: '6px',
            margin: '0 0 15px 0',
            fontStyle: 'italic'
          }}>
            {t.formTitle}
          </h2>

          <p style={{
            fontSize: '16px',
            color: 'rgba(201, 184, 150, 0.6)',
            marginBottom: '50px',
            letterSpacing: '2px'
          }}>
            {t.formSubtitle}
          </p>

          <form onSubmit={handleSubmit} style={{ textAlign: 'left' }}>
            <div style={{ marginBottom: '30px' }}>
              <label style={{
                display: 'block',
                fontSize: '14px',
                letterSpacing: '3px',
                textTransform: 'uppercase',
                color: '#c9b896',
                marginBottom: '10px'
              }}>
                {t.labelName}
              </label>
              <input
                type="text"
                required
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                style={{
                  width: '100%',
                  padding: '15px',
                  background: 'rgba(255,255,255,0.03)',
                  border: '1px solid rgba(201, 184, 150, 0.2)',
                  color: '#f5f4f0',
                  fontSize: '19px',
                  fontFamily: "'Cormorant Garamond', Georgia, serif",
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <div style={{ marginBottom: '30px' }}>
              <label style={{
                display: 'block',
                fontSize: '14px',
                letterSpacing: '3px',
                textTransform: 'uppercase',
                color: '#c9b896',
                marginBottom: '10px'
              }}>
                {t.labelEmail}
              </label>
              <input
                type="email"
                required
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                style={{
                  width: '100%',
                  padding: '15px',
                  background: 'rgba(255,255,255,0.03)',
                  border: '1px solid rgba(201, 184, 150, 0.2)',
                  color: '#f5f4f0',
                  fontSize: '19px',
                  fontFamily: "'Cormorant Garamond', Georgia, serif",
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <div style={{ marginBottom: '30px' }}>
              <label style={{
                display: 'block',
                fontSize: '14px',
                letterSpacing: '3px',
                textTransform: 'uppercase',
                color: '#c9b896',
                marginBottom: '10px'
              }}>
                {t.labelWhere}
              </label>
              <input
                type="text"
                required
                placeholder={t.placeholderWhere}
                value={formData.from}
                onChange={(e) => setFormData({...formData, from: e.target.value})}
                style={{
                  width: '100%',
                  padding: '15px',
                  background: 'rgba(255,255,255,0.03)',
                  border: '1px solid rgba(201, 184, 150, 0.2)',
                  color: '#f5f4f0',
                  fontSize: '19px',
                  fontFamily: "'Cormorant Garamond', Georgia, serif",
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <div style={{ marginBottom: '40px' }}>
              <label style={{
                display: 'block',
                fontSize: '14px',
                letterSpacing: '3px',
                textTransform: 'uppercase',
                color: '#c9b896',
                marginBottom: '10px'
              }}>
                {t.labelWhy}
              </label>
              <textarea
                required
                rows={5}
                placeholder={t.placeholderWhy}
                value={formData.why}
                onChange={(e) => setFormData({...formData, why: e.target.value})}
                style={{
                  width: '100%',
                  padding: '15px',
                  background: 'rgba(255,255,255,0.03)',
                  border: '1px solid rgba(201, 184, 150, 0.2)',
                  color: '#f5f4f0',
                  fontSize: '19px',
                  fontFamily: "'Cormorant Garamond', Georgia, serif",
                  outline: 'none',
                  resize: 'vertical',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <button
              type="submit"
              style={{
                width: '100%',
                background: 'none',
                border: '1px solid #c9b896',
                color: '#c9b896',
                fontSize: '13px',
                fontFamily: "'Cormorant Garamond', Georgia, serif",
                letterSpacing: '4px',
                cursor: 'pointer',
                padding: '20px',
                textTransform: 'lowercase',
                transition: 'all 0.4s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = '#c9b896';
                e.target.style.color = '#0a0a09';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'none';
                e.target.style.color = '#c9b896';
              }}
            >
              {t.send}
            </button>
          </form>

          <p style={{
            fontSize: '14px',
            color: 'rgba(245, 244, 240, 0.3)',
            marginTop: '40px',
            fontStyle: 'italic',
            lineHeight: '1.8'
          }}>
            {t.deadline}<br />
            {t.preference}
          </p>
        </div>
      </div>
    );
  }

  // Work Form
  if (formType === 'work') {
    return (
      <div style={{
        fontFamily: "'Cormorant Garamond', 'Garamond', 'Georgia', serif",
        minHeight: '100vh',
        background: '#0a0a09',
        color: '#f5f4f0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        padding: '60px 20px'
      }}>
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 400 400' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`,
          opacity: 0.02,
          pointerEvents: 'none'
        }} />

        <LanguageSwitcher />

        {/* Back button */}
        <button
          onClick={() => setFormType(null)}
          style={{
            position: 'absolute',
            top: '30px',
            left: '30px',
            background: 'none',
            border: 'none',
            color: 'rgba(201, 184, 150, 0.5)',
            fontSize: '17px',
            fontFamily: "'Cormorant Garamond', Georgia, serif",
            cursor: 'pointer',
            letterSpacing: '2px'
          }}
        >
          {t.back}
        </button>

        <div style={{ textAlign: 'center', zIndex: 1, maxWidth: '500px', width: '100%' }}>
          <h2 style={{
            fontSize: '34px',
            fontWeight: 300,
            letterSpacing: '6px',
            margin: '0 0 15px 0',
            fontStyle: 'italic'
          }}>
            {t.workTitle}
          </h2>

          <p style={{
            fontSize: '13px',
            color: 'rgba(201, 184, 150, 0.6)',
            marginBottom: '50px',
            letterSpacing: '2px'
          }}>
            {t.workSubtitle}
          </p>

          <form onSubmit={handleSubmit} style={{ textAlign: 'left' }}>
            <div style={{ marginBottom: '30px' }}>
              <label style={{
                display: 'block',
                fontSize: '14px',
                letterSpacing: '3px',
                textTransform: 'uppercase',
                color: '#c9b896',
                marginBottom: '10px'
              }}>
                {t.labelName}
              </label>
              <input
                type="text"
                required
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                style={{
                  width: '100%',
                  padding: '15px',
                  background: 'rgba(255,255,255,0.03)',
                  border: '1px solid rgba(201, 184, 150, 0.2)',
                  color: '#f5f4f0',
                  fontSize: '19px',
                  fontFamily: "'Cormorant Garamond', Georgia, serif",
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <div style={{ marginBottom: '30px' }}>
              <label style={{
                display: 'block',
                fontSize: '14px',
                letterSpacing: '3px',
                textTransform: 'uppercase',
                color: '#c9b896',
                marginBottom: '10px'
              }}>
                {t.labelEmail}
              </label>
              <input
                type="email"
                required
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                style={{
                  width: '100%',
                  padding: '15px',
                  background: 'rgba(255,255,255,0.03)',
                  border: '1px solid rgba(201, 184, 150, 0.2)',
                  color: '#f5f4f0',
                  fontSize: '19px',
                  fontFamily: "'Cormorant Garamond', Georgia, serif",
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <div style={{ marginBottom: '30px' }}>
              <label style={{
                display: 'block',
                fontSize: '14px',
                letterSpacing: '3px',
                textTransform: 'uppercase',
                color: '#c9b896',
                marginBottom: '10px'
              }}>
                {t.labelRole}
              </label>
              <input
                type="text"
                required
                placeholder={t.placeholderRole}
                value={formData.role}
                onChange={(e) => setFormData({...formData, role: e.target.value})}
                style={{
                  width: '100%',
                  padding: '15px',
                  background: 'rgba(255,255,255,0.03)',
                  border: '1px solid rgba(201, 184, 150, 0.2)',
                  color: '#f5f4f0',
                  fontSize: '19px',
                  fontFamily: "'Cormorant Garamond', Georgia, serif",
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <div style={{ marginBottom: '40px' }}>
              <label style={{
                display: 'block',
                fontSize: '14px',
                letterSpacing: '3px',
                textTransform: 'uppercase',
                color: '#c9b896',
                marginBottom: '10px'
              }}>
                {t.labelAbout}
              </label>
              <textarea
                required
                rows={5}
                placeholder={t.placeholderAbout}
                value={formData.experience}
                onChange={(e) => setFormData({...formData, experience: e.target.value})}
                style={{
                  width: '100%',
                  padding: '15px',
                  background: 'rgba(255,255,255,0.03)',
                  border: '1px solid rgba(201, 184, 150, 0.2)',
                  color: '#f5f4f0',
                  fontSize: '19px',
                  fontFamily: "'Cormorant Garamond', Georgia, serif",
                  outline: 'none',
                  resize: 'vertical',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <button
              type="submit"
              style={{
                width: '100%',
                background: 'none',
                border: '1px solid #c9b896',
                color: '#c9b896',
                fontSize: '13px',
                fontFamily: "'Cormorant Garamond', Georgia, serif",
                letterSpacing: '4px',
                cursor: 'pointer',
                padding: '20px',
                textTransform: 'lowercase',
                transition: 'all 0.4s ease'
              }}
              onMouseEnter={(e) => {
                e.target.style.background = '#c9b896';
                e.target.style.color = '#0a0a09';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = 'none';
                e.target.style.color = '#c9b896';
              }}
            >
              {t.send}
            </button>
          </form>

          <p style={{
            fontSize: '14px',
            color: 'rgba(245, 244, 240, 0.3)',
            marginTop: '40px',
            fontStyle: 'italic',
            lineHeight: '1.8'
          }}>
            {t.workNote}<br />
            {t.workNote2}
          </p>
        </div>
      </div>
    );
  }

  return null;
};

export default CorazonWTF;
